import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=680faf2a&"
import script from "./FormInput.vue?vue&type=script&lang=js&"
export * from "./FormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680faf2a')) {
      api.createRecord('680faf2a', component.options)
    } else {
      api.reload('680faf2a', component.options)
    }
    module.hot.accept("./FormInput.vue?vue&type=template&id=680faf2a&", function () {
      api.rerender('680faf2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FormInput.vue"
export default component.exports